import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonthsWithOneDecimal } from 'Utility/patientInfo';
import { showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from 'Components/InfoPopover';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { nsaa } from 'neuro-schemas';

const { calculateScore } = nsaa;

const NSAA = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.nsaa'} />}
      newButton={
        <DocumentCreationButton
          name="nsaa"
          text={'motor.newNSAA'}
          onClick={startEdit({}, 'nsaa')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'motor.nsaaScore'} />
            </Item>
          </>
        }
        contentFormat={d => {
          const score = calculateScore(d);
          return (
            <>
              <Item xs={2}>
                {showPatientAgeInMonthsOnForm(d.date) ? (
                  <FormattedMessage
                    id="motor.dateAndMonth"
                    values={{
                      date: formatPartialDate(d.date),
                      months: getPatientAgeInMonthsWithOneDecimal(d.date),
                    }}
                  />
                ) : (
                  formatPartialDate(d.date)
                )}
              </Item>
              <Item xs={6}>{score ?? <InfoPopover text="general.notFilled" color="primary" />}</Item>
            </>
          );
        }}
        makeControls
        historyRowControls={d => (
          <div id={'nsaaHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'nsaa'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default NSAA;
